export default __webpack_public_path__ + "static/media/logo.fb0e325c.svg";